import { WritingTable } from './WritingTable'
import { withWritingTable } from './withWritingTable'

const ConnectedWritingTable = withWritingTable(WritingTable)
export { ConnectedWritingTable as WritingTable }
